<ion-list class="ion-no-margin">
  <ion-item (click)="closePopover('faq')" class="item-hover">
    <ion-label>
      FAQ
    </ion-label>
  </ion-item>
  <ion-item (click)="closePopover('contactus')" lines="none" class="item-hover">
    <ion-label>
      Contact Details
    </ion-label>
  </ion-item>
</ion-list>
